import React from 'react';
import { LinkStyles } from '../../theme';
import { Dialog, DialogContent, DialogContentText, Typography } from '@mui/material';
import { ModalProps } from '../../utils/types';
import CloseIcon from './CloseIcon';

const LearnMorePCPModal = ({ open, handleClose }:ModalProps): JSX.Element => {
    return (
        <Dialog
            maxWidth='md'
            fullWidth={true}
            open={open}
            onClose={handleClose}
        >
            <DialogContent sx={{ padding: '30px' }}>
                <CloseIcon handleClose={handleClose}/>
                <DialogContentText>
                    <Typography sx={{ fontSize: '1.2rem', fontFamily: 'brandon-grotesque-medium,Sans-serif' }}>
                        Patients have full access to any location and provider at Perlman Clinic!
                        <br/>
                        <ul style={{ paddingLeft: '20px', lineHeight: '2.5rem', margin: '0px' }}>
                            <li>
                                <span style={LinkStyles}>PPO insurance plans</span>: you can see any provider at Perlman Clinic.
                            </li>
                            <li>
                                <span style={LinkStyles}>HMO insurance plans</span>: your insurance card likely lists a Primary Care Provider (PCP).
                                So long as the PCP on your card works at Perlman Clinic, we are a team-based model and you can
                                see any provider at Perlman Clinic.
                            </li>
                            <li>
                                <span style={LinkStyles}>No insurance</span>: you can see any provider at Perlman Clinic.
                            </li>
                        </ul>
                    </Typography>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default LearnMorePCPModal;
